module.exports = __webpack_public_path__ + "48d961470acd03f6fb1dfb707b1dbdf7.png";